import * as React from 'react';
import * as LabelPrimitive from '@radix-ui/react-label';

import { cn } from '../utils/utils';

/**
 * A plain string, not a `cva()`. Stock shadcn wraps this in CVA, but there was
 * no variants object, `labelVariants()` was only ever called with zero args,
 * and `VariantProps<typeof labelVariants>` resolved to `{}` — a constant
 * wearing a CVA costume. Reach for CVA here if a real variant appears.
 */
const labelClasses =
  'text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70';

const Label = React.forwardRef<
  React.ElementRef<typeof LabelPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof LabelPrimitive.Root>
>(({ className, ...props }, ref) => (
  <LabelPrimitive.Root
    ref={ref}
    className={cn(labelClasses, className)}
    {...props}
  />
));
Label.displayName = LabelPrimitive.Root.displayName;

export { Label };
